import styled from "styled-components";

export const Container = styled.div`
  padding: 64px 32px 128px;
  &.view-edit {
    padding: 0;
  }
  &.view {
    padding: 0;
  }

  h1 {
    width: 700px;
    margin: 0 auto 1.5rem;
    font-weight: 400;
    font-size: 2rem;
    position: relative;
    line-height: 2.5rem;
    padding-bottom: 1rem;
    color: var(--velotax-font-color-light);

    :after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 2px;
      width: 100px;
      background-color: var(--ant-primary-color);
    }
  }

  & > span.ant-typography {
    display: block;
    width: 700px;
    margin: 0 auto 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--velotax-font-color-light);

    span {
      cursor: pointer;
      font-weight: 500;
      color: var(--ant-primary-color);
    }
  }

  .edition-button-corretagem {
    display: flex;
    align-items: center;
    margin-top: 12px;
    background: var(--velotax-background-color);

    button {
      display: flex;
      align-items: center;

      span {
        margin-left: 8px;
      }
    }
  }

  .juridic-messages-container {
    width: 100%;
    opacity: 0.8;
    padding: 24px 0 0;

    .message {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-bottom: 1rem;
    }

    p {
      font-size: 0.75rem;
      font-weight: 400;
      text-align: justify;
      line-height: 1.4rem;
      color: var(--velotax-font-color-light);
      margin-bottom: 0;

      i {
        font-weight: bold;
        color: var(--velotax-font-color-light);
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    padding: 0 0 64px;

    .juridic-messages-container {
      margin: 0;
      width: 100%;
      p {
        margin-left: 0;
      }
    }

    h1 {
      max-width: calc(100% - 48px);
      margin: 0 24px 1.5rem;
      padding: 24px 0 1rem;
    }

    & > span.ant-typography {
      width: 100%;
      margin: 0 auto 1rem;
      padding: 0 24px;
    }
  }
`;

export const ButtonContent = styled.div`
  width: 700px;
  margin: 0 auto 8px;
  div {
    display: flex;
    justify-content: flex-end;
  }

  @media only screen and (max-device-width: 812px) {
    width: 100%;
    div {
      width: 100%;
      padding: 16px 24px 0;
      button {
        span {
          font-size: 11px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  @media only screen and (max-device-width: 576px) {
    div {
      button {
        width: 100%;
      }
    }
  }
`;

export const Content = styled.div`
  padding: 32px;
  &.second.view,
  &.second.view-edit {
    padding: 0 32px 32px;
  }
  &.second {
    padding: 32px;
    border: none;
    background-color: transparent;
  }
  .ant-divider {
    margin: 8px 0 24px;
  }
  h3.date-title {
    font-size: 24px;
    font-weight: 700;
  }
  margin: 0 auto;
  max-width: 700px;
  border-radius: 4px;
  background-color: var(--velotax-background-color);
  h3 {
    display: flex;
    align-items: center;
    column-gap: 16px;
    font-size: 20px;
    color: var(--velotax-font-color-light);
    margin-bottom: 0;
    user-select: none;
  }
  .desc-label {
    display: flex;
    align-items: center;
    svg {
      fill: var(--ant-primary-color);
    }
  }
  .month-chevron {
    width: 32px;
    height: 32px;
    cursor: pointer;
    &.disabled {
      opacity: 0.15;
      cursor: default;
    }
  }
  .desc-content {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    column-gap: 8px;
    svg {
      fill: var(--ant-primary-color);
    }
    span {
      align-self: center;
    }
    button {
      min-width: 32px;
    }
  }
  .market {
    opacity: 0.6;
    font-weight: bold;
  }
  .ml-40 {
    margin-left: 40px;
  }
  .btn-icon {
    padding: 0;
    width: 48px;
    display: flex;
    .MuiTouchRipple-root {
      width: 48px;
    }
  }
  .add {
    float: right;
    min-width: 128px;
    margin-bottom: 16px;
  }
  .ant-descriptions-view {
    border-radius: 4px !important;
    .ant-descriptions-item-label {
      width: 60%;
      padding: 10px 16px;
      color: var(--velotax-font-color-light) !important;
    }
    .ant-descriptions-item-content {
      padding: 10px 16px;
      text-align: center;
      /* background-color: #3d3d3d !important; */
      span {
        color: var(--velotax-font-color-light) !important;
      }
    }
  }
  .ant-list.ant-list-split {
    clear: both;
    padding: 0 16px;
    background-color: var(--velotax-ghost);
    border: 1px solid var(--velotax-ghost);
    border-radius: 4px;
    .ant-list-item-action > li {
      padding: 0;
    }
  }
  .ant-list-item-action > li,
  .ant-list-item-meta-title,
  .ant-list-item-meta-description {
    color: var(--velotax-font-color-light);
  }
  .ant-list-item-meta-description {
    opacity: 0.75;
  }
  .list-description {
    display: flex;
    flex-direction: column;
  }
  .min-darf-price {
    margin-top: 24px;
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
  .text-center {
    display: block;
    text-align: center;
  }
  .ant-collapse-header {
    padding: 12px 0 !important;
  }
  .ant-collapse-content-box {
    padding: 16px 0 !important;
  }
  .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow
    svg {
    transform: rotate(-90deg);
  }
  .ant-collapse-item-disabled {
    & > .ant-collapse-header {
      cursor: default;
      .ant-collapse-arrow {
        opacity: 0;
      }
    }
  }
  .ant-collapse-header-text {
    width: 100%;
  }
  .total-tax-header {
    width: calc(100% - 48px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.original {
      h3:last-of-type {
        width: 40%;
      }
    }
    h3 {
      margin: 0 0 8px;
    }
  }

  @media only screen and (max-device-width: 812px) {
    width: 100%;
    padding: 24px;
    border-radius: 0;
    &.first {
      padding: 24px;
    }
    &.second {
      padding: 24px !important;
      border-top: 1px solid #313131;
    }
    h3 {
      font-size: 18px;
    }
    .anticon.anticon-right.ant-collapse-arrow {
      top: 24px;
    }
    .desc-content {
      column-gap: 2px;
      flex-direction: row;
      &.is-editting {
        row-gap: 8px;
        flex-direction: column;
        button {
          width: 100%;
        }
      }
      &:not(.is-editting) {
        span {
          line-height: 32px;
        }
        button {
          margin-top: -2px;
        }
      }
      &.ml-40 {
        margin-left: 0;
      }
    }
    .market {
      font-size: 11px;
      letter-spacing: -0.1px;
    }
  }
`;

export const BolsaOperations = styled.div`
  border-radius: 4px;
  position: relative;
  color: var(--velotax-font-color-light);
  background-color: var(--velotax-ghost);
  border: 1px solid var(--velotax-background-color-ghost);

  .no-plan {
    span {
      user-select: none;
    }
  }

  .no-plan-container {
    position: absolute;
    top: 55px;
    left: 40%;
    width: 60%;
    z-index: 3;
    display: flex;
    padding: 8px;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-color: #fff4;
    border-radius: 0 0 8px 0;
    height: calc(100% - 55px);
    backdrop-filter: blur(4px);
    border-left: 1px solid var(--velotax-background-color-ghost);
    .ant-btn {
      margin-top: 8px;
    }
  }

  div.strong span {
    font-weight: 700 !important;
  }
  div.opacity {
    opacity: 0.8;
  }

  div.header,
  div.sub-header,
  div.row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    span + span {
      text-align: center;
      justify-content: center;
    }
  }

  div.sub-header,
  div.row {
    height: auto;
    min-height: 48px;
    border-top: none;
    & + div.sub-header {
      border-top: 1px solid var(--velotax-background-color-ghost);
    }
    & > span + span {
      background-color: var(--velotax-background-color);
    }
    & > span {
      padding: 8px 16px;
      display: flex;
      align-items: center;
      border-left: none;
      & + span {
        border-left: 1px solid var(--velotax-background-color-ghost);
      }
    }
    &:last-of-type > span:last-of-type {
      border-radius: 0 0 4px 0;
    }
  }

  div.header {
    padding: 16px;
    border-radius: 4px 4px 0 0;
    background-color: var(--velotax-background-color-ghost);
    span {
      font-weight: 700;
    }
    button {
      display: none;
    }
  }

  div.sub-header {
    font-size: 14px;
    & > span {
      font-weight: 500;
    }
  }

  div.row {
    opacity: 0.85;
    font-size: 13px;
    border-top: 1px solid var(--velotax-background-color-ghost);
  }

  @media only screen and (max-device-width: 812px) {
    position: relative;
    overflow-x: hidden;
    span {
      font-size: 12px;
      button {
        max-width: 24px;
        min-width: 24px;
      }
    }
    .no-plan-container {
      left: 50%;
      width: 50%;
      font-size: 14px;
      line-height: 18px;
    }
    div.header,
    div.sub-header,
    div.row {
      width: 200%;
      height: auto;
      min-height: 48px;
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    div.sub-header,
    div.row {
      & > span {
        padding: 12px;
      }
    }

    div.header {
      padding: 16px 0;
    }
    div.header > span + span {
      padding: 0 8px;
      justify-content: space-between;
    }

    div.header > span:first-of-type,
    div.sub-header > span:first-of-type {
      position: sticky;
      left: 0;
    }
    div.header > span.show,
    div.sub-header > span.show {
      opacity: 1;
      z-index: 2;
    }
    div.header > span,
    div.sub-header > span {
      opacity: 0;
      z-index: 1;
    }
    div.header > span {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 8px;
    }
    div.header {
      button {
        display: flex;
      }
    }
    div.header > span.show svg polyline {
      stroke: var(--velotax-font-color);
    }
  }
`;
